<script>
    import { onMount } from 'svelte';
    import { MDCDialog } from '@material/dialog';

    import { TS } from '../config/translation-keys.js';
    import { t9n } from '../lib/translate.js';
    import { show_message } from '../lib/flash';
    import CheckBox from '../lib/components/CheckBox.svelte';
    import APIClient from '../state-charts/api-client';
    import session from '../lib/session';

    export let worker_uuid;
    export let publicCV = false;
    let dialog;
    let share_url;
    let share_btns;
    let share_merchant_color = false;
    let share_merchant_color_label = t9n(TS.CV_SHARE_MERCHANT_COLOR)

    const get_share_url = () => {
        if (!publicCV) {
            if ($session?.merchant?.merchant_uuid && share_merchant_color) {
                share_url = encodeURI(`${location.origin}/cv/worker/${worker_uuid}?merchant_uuid=${$session.merchant.merchant_uuid}`)
            } else{
                share_url = encodeURI(`${location.origin}/cv/worker/${worker_uuid}`);
            }
        } else {
            share_url = window.location;
        }
    }

    const change_btn_link = () => {
        share_btns = [
            {
                alt: 'Facebook',
                img: '/assets/material-social-icons/facebook.png',
                href: 'https://facebook.com/sharer/sharer.php?u=' + share_url,
            },
            {
                alt: 'Twitter',
                img: '/assets/material-social-icons/twitter.png',
                href: 'https://twitter.com/share?url=' + share_url,
            },
            {
                alt: 'LinkedIn',
                img: '/assets/material-social-icons/linkedin.png',
                href: 'https://www.linkedin.com/sharing/share-offsite/?url='  + share_url,
            },
            {
                alt: 'Pinterest',
                img: '/assets/material-social-icons/pinterest.png',
                href: 'https://pinterest.com/pin/create/bookmarklet/?&url=' + share_url,
            },
            {
                alt: 'WhatsApp',
                img: '/assets/material-social-icons/whatsapp.png',
                href: 'whatsapp://send?text=' + share_url,
            },
            {
                alt: 'StumbleUpon',
                img: '/assets/material-social-icons/stumbleupon.png',
                href: 'https://stumbleupon.com/submit?url=' + share_url,
            },
            {
                alt: 'Email',
                img: '/assets/material-social-icons/mail.png',
                href: 'mailto:?&body=' + share_url,
            },
        ];
    }
    const copy_to_clipboard = () => {

        get_share_url();
        let input = document.getElementById('myInput');
        input.value = share_url;
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        close();
        show_message(t9n(TS.ORDER_COPIED_LINK), 'success');
    };

    const init_share = async () => {
        dialog = new MDCDialog(document.getElementById(`share-dialog`));
    };

    export const open = () => dialog.open();

    export const close = () => dialog.close();

    $: if(share_merchant_color || !share_merchant_color){
        get_share_url();
        change_btn_link();
    }

    onMount(init_share);

    // reactive functions ------------------------------------------------------- //


</script>

<div id="share-dialog" class="mdc-dialog">
    <div class="mdc-dialog__container">
        <div
                class="mdc-dialog__surface"
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="my-dialog-title"
                aria-describedby="my-dialog-content">

            <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
            <h2 class="mdc-dialog__title" id="my-dialog-title">
                { t9n(TS.CV_SHARE)}
            </h2>

            <div class="mdc-dialog__content" id="my-dialog-content">
                <input type="text" value={share_url} id="myInput"/>
                <div style='display: flex'>
                    {#if !!share_btns}
                        {#key share_btns}
                            {#each share_btns as button, i}
                                <a href={button.href} target='_blank'>
                                    <img src={button.img} alt={button.alt} width="50"/>
                                </a>

                            {/each}
                        {/key}
                    {/if}
                </div>

            </div>

            {#if publicCV === false}
                <div style='margin-left: 20px'>
                    <CheckBox
                      id='cv_merchant_color'
                      bind:value={share_merchant_color}
                      label={share_merchant_color_label} />
                </div>
            {/if}

            <footer class="mdc-dialog__actions">
                <!--                {#each buttons as button}-->
                <!--                    <button class="mdc-button mdc-button&#45;&#45;raised {button.classes}"-->
                <!--                            tabindex="0"-->
                <!--                            on:click|preventDefault|stopPropagation={button.action}>-->
                <!--                        {button.label}-->
                <!--                    </button>-->
                <!--                {/each}-->

                <button
                        on:click={() => copy_to_clipboard()}
                        class="mdc-button mdc-button--unelevated">
                    <span class="mdc-button__ripple"/>
                    <i class="material-icons">file_copy</i>
                    {t9n(TS.TXT_COPY_LINK)}
                </button>

                <button
                        on:click={() => close()}
                        class="btn-close mdc-button mdc-button--unelevated">
                    <span class="mdc-button__ripple"/>
                    {t9n(TS.LOGIN_FORM_CLOSE)}
                </button>
            </footer>
        </div>
    </div>

    <div class="mdc-dialog__scrim"/>
</div>

<style>
    #share-dialog .mdc-dialog__surface {
        max-width: 450px;
        width: 450px;
    }

    #share-dialog .mdc-dialog__content {
        margin-left: 15px;
    }

    #share-dialog .material-icons {
        margin-left: -5px;
        margin-right: 5px;
    }

    #share-dialog input {
        position: absolute;
        top: -1000px;
        left: -1000px;
    }

    .btn-close {
        margin-left: 5px;
    }

    /* Mobile Mode
      *******************************************************/
    @media (min-width: 0) and (max-width: 768px) {
        #share-dialog .mdc-dialog__surface {
            max-width: min-content;
            width: 100%;
        }
    }
</style>